let mapper_options = {
  endpoint: 'filters',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      },
      division: {
        foreignKey: 'division_id',
        localField: 'division'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('smart_group', mapper_options)
}
